import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../Models/SkeletonSizesBase';

@Component({
  selector: 'skc-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.less']
})
export class SkeletonComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-type') type: 'circle' | 'box' | 'line' = 'box';
  @Input('skc-text') text: string;
  @Input('skc-image') image: string;
  @Input('skc-image-color') imageColor: string;
  @Input('skc-image-width') imageWidth: string;
  @Input('skc-image-height') imageHeight: string;
  showText = false;
  @Input('skc-show-img') showImg = false;
  @Input('skc-src-img') srcImg: string;
  imageSrcStyle;

  constructor() {
    super();
  }

  ngOnInit() {
    this.isVisibleText();
  }

  isVisibleText() {
    this.showText = this.text !== '';
  }

  backgroundImageStyle(url) {
    return {
      '-webkit-mask': 'url(' + url + ')',
      mask: 'url(' + url + ')'
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.image) {
      this.imageSrcStyle = this.backgroundImageStyle(this.image);
    }
  }
}
